import AdminLayout from "../../components/admin/layout/AdminLayout";
import ManagerSidebar from "../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import Dashboard from "../../components/managerLiveDashboard/dashboard/Dashboard";

function ManagerDashboardPage() {
  return (
    <AdminLayout sidebarComponent={ManagerSidebar}>
      <Dashboard />
    </AdminLayout>
  );
}

export default ManagerDashboardPage;
